export const alphaNumericPattern = /^[a-zA-Z0-9]*$/;
export const alphaNumericSpacePattern = /^[a-z\d\-_\s]+$/i;
export const commaSeparatedPattern = /^[a-zA-Z0-9]+(,[a-zA-Z0-9]+)*$/;
